import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    console.log("Product sort controller connected")
  }

  sortProducts(event) {
    const sortValue = this.selectTarget.value
    const url = new URL(window.location)

    if (sortValue === 'relevancy') {
      url.searchParams.delete('sort_field')
      url.searchParams.delete('sort_direction')
    } else {
      const [sortField, sortDirection] = sortValue.split('-')
      url.searchParams.set('sort_field', sortField)
      url.searchParams.set('sort_direction', sortDirection)
    }

    // Reset to page 1 when sorting changes
    url.searchParams.set('page', '1')

    window.location = url.toString()
  }
}
